export function vehicleDetailPath(vehicleOrId) {
  const id = typeof vehicleOrId === 'string' ? vehicleOrId : vehicleOrId?.id;
  if (!id) return '/inventory';
  return `/inventory/${encodeURIComponent(id)}`;
}

export function vehicleHeadline(vehicle) {
  if (!vehicle) return '';
  return [vehicle.year, vehicle.make, vehicle.model, vehicle.trim].filter(Boolean).join(' ');
}

export function localizedVehicleText(language, en, es) {
  if (language === 'es') {
    const s = typeof es === 'string' ? es.trim() : '';
    if (s) return s;
  }
  return en ?? '';
}

export function localizedVehicleList(language, enList, esList) {
  const en = Array.isArray(enList) ? enList.filter((x) => typeof x === 'string' && x.trim()) : [];
  const es = Array.isArray(esList) ? esList.filter((x) => typeof x === 'string' && x.trim()) : [];
  if (language === 'es' && es.length > 0) return es;
  return en;
}

export function formatMileage(mileage) {
  const n = Number(mileage);
  if (!Number.isFinite(n)) return '';
  return `${n.toLocaleString()} mi`;
}

export function vehicleStatusLabel(vehicle, t) {
  const status = String(vehicle?.status || '').toLowerCase();
  if (status === 'available') return t('featured.available');
  if (status === 'pending') return t('featured.pending');
  if (status === 'sold') return t('featured.sold');
  return vehicle?.status || '';
}
